import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import BillCreateContainer from "@legacy/bills/BillCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { BILLS_ROUTES } from "@routes/bills"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function BillEdit() {
    const isDesktop = useIsDesktop()

    const billId = window.BILL_ID
    const isDraft = window.BILL_IS_DRAFT

    const [listRoute, detailsRoute] = useSlugExtractor([BILLS_ROUTES.LIST, BILLS_ROUTES.DETAILS], billId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const listBackDestination = hasPermission("bills_list_permission", PERMISSION_LEVEL.FULL) ? listRoute : undefined
    const detailsBackDestination = hasPermission("bills_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root pageId="BillEdit">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Bills"
                            icon={icon({ name: "file-invoice-dollar", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "file-invoice-dollar", style: "solid", family: "sharp" })}
                            destination={listBackDestination}
                            iconOnly={!isDesktop}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle
                            label={isDraft ? "New Bill" : "Edit Bill"}
                            backDestination={detailsBackDestination}
                        />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <BillCreateContainer formMode="EDIT_BILL" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
